import { Injectable } from '@angular/core'

import { ResourceSlug } from '../../../shared/enums/wordpress/wp-resource-slug.enum'
import { Paginator } from '../../../shared/interfaces/paginator.interface'
import { CatalogueService } from '../../../shared/services/catalogue.service'
import { MetricUseCase } from '../../tools-catalogue/interfaces/metric-use-case.interface'
import { MetricUseCaseDto } from '../../tools-catalogue/resources/metric-use-case/dtos/metric-use-case.dto'
import { CatalogueResourceSlug } from '../enums/catalogue-resource-slug.enum'

@Injectable({
  providedIn: 'root'
})
export class MetricUseCaseService {
  constructor(private catalogueService: CatalogueService) {}

  list(listParams: {
    ids?: number[]
    targetSectorIds?: number[]
    objectiveIds?: number[]
    purposeIds?: number[]
    page?: number
    orderBy?: string
    orderByDesc?: string
    withoutPagination?: boolean
  }): Promise<Paginator<MetricUseCase> | MetricUseCase[]> {
    const params = Object.assign({}, listParams)

    if (params.withoutPagination) {
      params.withoutPagination = true
    }

    if (params.orderBy) {
      if (params.orderBy === 'nameAsc') {
        params.orderBy = 'name'
      }
      if (params.orderBy === 'nameDesc') {
        params.orderBy = 'name'
        params.orderByDesc = 'true'
      }
    }

    if (params.withoutPagination) {
      return this.catalogueService.list('metric-use-cases', params) as Promise<
        MetricUseCase[]
      >
    } else {
      return (
        this.catalogueService.list('metric-use-cases', params) as Promise<
          Paginator<MetricUseCase>
        >
      ).then((paginatorRes: Paginator<MetricUseCase>) =>
        Object.assign(
          paginatorRes,
          paginatorRes.data ? paginatorRes.data : { data: [] }
        )
      )
    }
  }

  show(slug: string): Promise<MetricUseCase> {
    return this.catalogueService.showBySlug(
      ResourceSlug.MetricUseCases,
      slug
    ) as Promise<MetricUseCase>
  }

  store(metricDto: MetricUseCaseDto) {
    return this.catalogueService.store(
      CatalogueResourceSlug.MetricUseCases,
      metricDto
    )
  }
}
